export default {
  init() {

    //Connecting tab floats
    let tabBlocks = [];
    $(".tab-block").each(function(){
      tabBlocks.push(this);
    });

    $('.tabs__menu.tab-connect li a').each(function(){
      $(this).click(function(e){
        e.preventDefault()
        $('.tabs__menu li.active').removeClass('active');
        $(this).parent().addClass('active')
        $('.tab-block.active').removeClass('active');
        let tabnr = $(this).attr('tabnumber');
        $(tabBlocks[tabnr]).addClass("active");
      })
    })

    //Mobile tab scroll
    $('.tabs__mobile-movement--right').click(function(){
      $('.tabs__wrapper--sub').animate({ scrollLeft: "+=150px" }, 300);
      checkPositions()
      $('.tabs__mobile-movement--left').removeClass('disable')
    });

    $('.tabs__mobile-movement--left').click(function(){
      $('.tabs__wrapper--sub').animate({ scrollLeft: "-=150px" }, 300);
      checkPositions()
      $('.tabs__mobile-movement--right').removeClass('disable')
    });

    $(".tabs__wrapper").on("touchend", function(){
      checkPositions()
    });

    function checkPositions() {
      let positionLeft = $('.tabs__wrapper--sub .tabs__menu').position()
      let wrapperWidth = $('.tabs__wrapper--sub .tabs__menu').width()
      let displayWidth = $(window).width()
      let maxPosition = wrapperWidth - displayWidth
      console.log(positionLeft.left * -1, wrapperWidth, displayWidth, maxPosition)
      if(maxPosition - 150 <= (positionLeft.left * -1)) {
        console.log('1')
        $('.tabs__mobile-movement--right').addClass('disable')
      }
      else if(positionLeft.left * -1 <= 150) {
        console.log('2')
        $('.tabs__mobile-movement--left').addClass('disable')
      }
      else if(positionLeft.left * -1 > 0 && positionLeft.left < maxPosition) {
        console.log('3')
        $('.tabs__mobile-movement--left').removeClass('disable')
        $('.tabs__mobile-movement--right').removeClass('disable')
      }
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/prices.js